<template>
  <div>
    <transition name="bounce">
      <div v-if="isSubmitted" class="loading-modal">
        <isSigning></isSigning>
      </div>
    </transition>
    <div class="container" :style="isSubmitted ? 'display: none;' : ''">
      <navBar/>

      <transition :name="routerTransition">

        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
          <div
            class="content-area__heading"
            :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
            <h4 class="mb-1">Pasos Firma Electrónica Simple con Identidad</h4>
          </div>

          <!-- BREADCRUMB -->
          <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

        </div>
      </transition>


      <div class="vx-row">
        <div class="vx-col sm:w-full md:w-full lg:w-2/3">
          <vs-card class="sing-simple">
            <div v-if="pendingVerificationUrl" class="p-4">
              <h1 class="mb-3">Valida tu identidad desde tu teléfono</h1>
              <div>
                <p>Usarás la cámara de tu teléfono para fotografiar tu INE y hacer la prueba de vida.</p>
                <h2><span>Paso 1:</span> En la siguiente pantalla verás un código QR</h2>
                <h2><span>Paso 2:</span> Escanéalo con tu teléfono y sigue las instrucciones</h2>
                <h2><span>Paso 3:</span> Regresa a esta computadora para dibujar tu firma</h2>

                <vs-alert class="mt-5" color="warning">
                  No cierres esta pestaña. Cuando termines en tu teléfono, aquí continuarás con tu firma automáticamente.
                </vs-alert>

                <div class="sm:flex justify-end">
                  <vs-button class="mt-5" color="primary" @click="goToVerification">
                    Continuar
                  </vs-button>
                </div>
              </div>
            </div>
            <div v-else class="p-4">
              <h1 class="mb-3">Instrucciones de firmado</h1>
              <div>

                <p>Firmarás tu documento mediante tu identidad, para eso <b>requeriremos tu INE vigente</b>. Si no cuentas con este documento o eres extranjero, no podrás firmar.</p>
                <h2><span>Paso 1:</span> Ten tu INE a la mano</h2>
                <h2><span>Paso 2:</span> Verifica tu identidad</h2>
                <h2><span>Paso 3:</span> Dibuja tu firma</h2>
                <div>
                  <vs-checkbox class="mt-6 d-inline-b" v-model="checkedTerms"></vs-checkbox>
                  <span class="terms">Acepto los <a target="_blank" href="https://verificamex.com/terminos-y-condiciones">Términos y Condiciones</a> del servicio y el <a target="_blank" href="https://verificamex.com/aviso-de-privacidad">Aviso de Privacidad Integral</a>.</span>
                </div>

                <div class="sm:flex justify-between">
                  <vs-button class="mt-5 mr-3" color="secondary" type="filled" @click="toggleTab(1)">Anterior</vs-button>

                  <vs-button :disabled="isButtonDisabled" ref="loadableButton" id="button-with-loading" class="mt-5 vs-con-loading__container" @click="startSignatureFlow" color="primary">
                    Validar identidad
                    <feather-icon icon="Edit3Icon" class="top-4 text-primary" svgClasses="w-4 h-4  text-white"></feather-icon>
                  </vs-button>
                </div>
              </div>
            </div>
          </vs-card>
        </div>

        <div class="vx-col sm:w-full md:w-full lg:w-1/3">

          <vs-card>
            <div class="p-4">
              <h4 class="mb-3">Firma del documento</h4>
              <div>
                <p class="mb-1">Es importante que revises el documento antes de firmar.</p>
                <p class="mb-0">Este proceso modifica tu documento original agregando los elementos necesarios para este formato de firma.</p>
              </div>
            </div>
          </vs-card>

          <vs-card>
            <div class="p-4">
              <h4 class="mb-3">Información</h4>
              <div>
                <p class="mb-3">Los datos introducidos serán almacenados como expediente digital de la firma, no se compartiran con terceros ni utilizados para ningún otro proceso.</p>
                <p class="mb-3">Al firmar el documento todos los datos serán enviados por un servidor seguro y los datos estarán resguardados con los más altos estánderes de seguridad.</p>
                <span>
                  <vs-alert class="d-inline-block" color="success">
                    ¿Qué es la Firma Electrónica Simple?
                      <vx-tooltip class="d-inline-block" text="Más información" position="top">
                        <a target="_blank" href="https://ayuda.verificamex.com/article/16-que-es-la-e-firma">
                          <feather-icon icon="HelpCircleIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-success"></feather-icon>
                        </a>
                      </vx-tooltip>
                  </vs-alert>
                </span>

                <span class="pr-1">
                  <vs-alert class="d-inline-block" color="primary">
                      No tengo INE a la mano
                    <vx-tooltip class="d-inline-block" text="Más información" position="top">
                      <a target="_blank" href="https://ayuda.verificamex.com/article/19-obtener-la-e-firma-por-primera-vez">
                        <feather-icon icon="HelpCircleIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-primary"></feather-icon>
                      </a>
                    </vx-tooltip>
                  </vs-alert>
                 </span>
              </div>
            </div>
          </vs-card>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {quillEditor} from "vue-quill-editor";
import router from "../../../../router";
import isSigning from "./isSigning";

export default {
  name: "SignSimple",
  components: {
    navBar,
    isSigning
  },
  props: ['toggleTab'],
  data () {
    return {
      isSubmitted: false,
      icon: 'EyeIcon',
      type: 'password',
      cer: null,
      key: null,
      password: null,
      uuid: null,
      checkedTerms: false,
      isButtonDisabled: false,
      pendingVerificationUrl: null
    }
  },
  computed: {
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  },
  methods: {
    goToVerification() {
      window.location.replace(this.pendingVerificationUrl)
    },
    startSignatureFlow() {
      this.isButtonDisabled = true
      if (!this.checkedTerms) {
        this.$vs.notify({
          title: 'Información',
          text: 'Debes aceptar los términos y condiciones para continuar.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          position: 'top-center',
          time: 8000
        })
        this.isButtonDisabled = false
        return
      }
      this.$store.dispatch("document/startSignatureFlow", {signatureId: this.uuid}).then(
        providerData => {
          // En computadora, la verificación V3 muestra un QR para hacerla en el teléfono y, al
          // terminar, regresa sola a esta pestaña para firmar: se avisa antes de salir. En el
          // teléfono (o en V2) se va directo y el firmante termina en el mismo dispositivo.
          if (providerData.version === 'v3' && !this.isMobileDevice) {
            this.pendingVerificationUrl = providerData.verificationUrl
            return
          }
          window.location.replace(providerData.verificationUrl)
        },
        error => {
          this.isButtonDisabled = false
          console.log(error)
          this.$vs.notify({
            title: 'Información',
            text: 'Haz alcanzado en número maximo de intentos, contacta al creador del documento.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'top-center',
            time: 8000

          })
        }
      )
    },
    toggleAcceptedTerms(value) {
      this.acceptedTerms = value;
    }
  },
  created() {
    let uuid = this.$route.params.uuid;
    if (uuid) {
      this.uuid = uuid;
    } else {
      router.push("/");
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
  h1, .h1 {
    font-size: 25px;
  }
  .loading-modal {
    position: absolute;
    transform: translateY(-18px);
    width: 100vw;
    height: 100vh;
    background-color: #fcfcfc;
    z-index: 100000000;
  }
  .sing-simple{
    ul {
      list-style-type: disc;
      padding-left: 20px;
      margin: 10px 0 20px;

      li {
        margin-bottom: 5px;
        line-height: 1.5;
      }
    }
    h2{
      font-size: 20px;
      margin-top: 15px;
      span{
        color: rgba(var(--vs-primary), 1);
        font-weight: 700;
      }
    }
  }
.terms{
  position: relative;
  top: -5px;
}
.d-inline-b {
  display: inline-block!important;
}
</style>
